import { v4 as uuid } from 'uuid';
import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import omit from 'lodash/omit';

import { types, STORAGE_KEY } from '../actions/user';
import { parseStats } from '../factories/StatFactory';

import { loadItem, saveItem } from '../utilities/localStorage';
import api from '../services/api';

const getUsers = state => state.users.results;

const getIndex = (data, payloadId) =>
  data.findIndex(item => item.id === payloadId);

const replaceItem = (data, item) => {
  const index = getIndex(data, item.id);
  return index > -1 ? [
    ...data.slice(0, index),
    item,
    ...data.slice(index+1),
  ] : [...data, item];
};

const removeItem = (data, item) => {
  const index = getIndex(data, item.id);
  return index > -1 ? [
    ...data.slice(0, index),
    ...data.slice(index+1),
  ] : data;
};

const createUser = name => ({
  isPlaceholder: true,
  id: uuid(),
  name,
});

// Load Users
//
function* loadUsers({ payload }) {
  try {
    const users = yield call(loadItem, STORAGE_KEY, []);
    yield put({ type: types.LOAD_USERS_SUCCESS, payload: { users } });
    yield put({ type: types.FETCH_USERS, payload: { users } });
  } catch(e) {
    console.error(e);
    yield put({ type: types.LOAD_USERS_SUCCESS, payload: { users: [] } });
  }
}


// Save Users
//
function* saveUsers({ payload }) {
  try {
    const { users } = payload;
    yield call(saveItem, STORAGE_KEY, users.map(user => omit(user, 'loaded')));
    yield put({ type: types.SAVE_USERS_SUCCESS, payload: { users } });
  } catch(e) {
    console.error(e);
    yield put({ type: types.SAVE_USERS_FAILED });
  }
}


// Add User
//
function* addUser({ payload }) {
  try {
    const { name } = payload;
    const baseUser = yield call(createUser, name);

    const currentUsers = yield select(getUsers);
    const users = yield call(replaceItem, currentUsers, baseUser);

    yield put({ type: types.ADD_USER_PLACEHOLDER, payload: { users } });
    yield put({ type: types.FETCH_USER, payload: { user: baseUser } });

    const fetchAction = yield take(types.FETCH_USER_SUCCESS);
    const user = fetchAction.payload.user;
    const usersUpdate = yield call(replaceItem, users, user);

    yield put({ type: types.SAVE_USERS, payload: { users: usersUpdate } });
    yield take(types.SAVE_USERS_SUCCESS);
    yield put({ type: types.ADD_USER_SUCCESS, payload: { users: usersUpdate } });
  } catch(e) {
    console.error(e);
  }
}


// Remove User
//
function* removeUser({ payload }) {
  try {
    const currentUsers = yield select(getUsers);
    const users = yield call(removeItem, currentUsers, payload);
    yield put({ type: types.SAVE_USERS, payload: { users } });
    yield take(types.SAVE_USERS_SUCCESS);
    yield put({ type: types.REMOVE_USER_SUCCESS, payload: { users } });
  } catch(e) {
    console.error(e);
  }
}


// Fetch All Users
//
function* fetchUsers({ payload }) {
  try {
    const users = yield payload.users.map(user => call(fetchUser, { payload: { user } }));
    yield put({ type: types.SAVE_USERS, payload: { users } });
  } catch(e) {
    yield put({ type: types.FETCH_USERS_FAILED, message: e.message });
  }
}

function* fetchUser({ payload }) {
  const userStats = yield call(api.getUser, payload.user.name);
  const user = {
    loaded: true,
    ...parseStats(
      { id: payload.user.id, name: payload.user.name },
      userStats
    )
  };
  yield put({ type: types.FETCH_USER_SUCCESS, payload: { user } });
  return user;
}

function* fetchUserSuccess({ payload }) {
  const currentUsers = yield select(getUsers);
  const users = yield call(replaceItem, currentUsers, payload.user);
  yield put({ type: types.FETCH_USERS_SUCCESS, payload: { users } });
}

function* userSaga() {
  yield [
    takeEvery(types.LOAD_USERS, loadUsers),
    takeEvery(types.SAVE_USERS, saveUsers),
    takeEvery(types.ADD_USER, addUser),
    takeEvery(types.REMOVE_USER, removeUser),
    takeEvery(types.FETCH_USER, fetchUser),
    takeEvery(types.FETCH_USERS, fetchUsers),
    takeEvery(types.FETCH_USER_SUCCESS, fetchUserSuccess),
  ];
}


export default userSaga;



// WEBPACK FOOTER //
// ./src/sagas/UserSaga.js